const IMAGE_URL_PATTERN = /\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i;
const VIDEO_URL_PATTERN = /\.(mp4|mov|webm|m4v|avi|mkv)(\?.*)?$/i;
const getYouTubeVideoId = (url) => {
    const cleanedUrl = url.trim();
    const watchMatch = cleanedUrl.match(/(?:youtube\.com\/watch\?v=)([^&?/\n]+)/);
    if (watchMatch?.[1])
        return watchMatch[1];
    const shortMatch = cleanedUrl.match(/(?:youtu\.be\/)([^&?/\n]+)/);
    if (shortMatch?.[1])
        return shortMatch[1];
    const embedMatch = cleanedUrl.match(/(?:youtube\.com\/embed\/)([^&?/\n]+)/);
    if (embedMatch?.[1])
        return embedMatch[1];
    return null;
};
const getVimeoVideoId = (url) => {
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
    return match?.[1] || null;
};
const getCloudinaryVideoThumbnail = (url) => {
    // Transform Cloudinary video delivery URL into a first-frame image thumbnail URL.
    // Example:
    // .../video/upload/v123/sample.mp4 -> .../video/upload/so_0/sample.jpg
    if (!url.includes('res.cloudinary.com') || !url.includes('/video/upload/'))
        return null;
    const [pathPart] = url.split('?');
    const transformed = pathPart.replace('/video/upload/', '/video/upload/so_0/');
    return transformed.replace(/\.[^./]+$/, '.jpg');
};
const getVideoPreviewImage = (url) => {
    if (!url)
        return null;
    const value = url.trim();
    if (!value)
        return null;
    if (IMAGE_URL_PATTERN.test(value))
        return value;
    const youtubeId = getYouTubeVideoId(value);
    if (youtubeId)
        return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    const vimeoId = getVimeoVideoId(value);
    if (vimeoId)
        return `https://vumbnail.com/${vimeoId}.jpg`;
    const cloudinaryThumbnail = getCloudinaryVideoThumbnail(value);
    if (cloudinaryThumbnail)
        return cloudinaryThumbnail;
    if (VIDEO_URL_PATTERN.test(value)) {
        return value.replace(VIDEO_URL_PATTERN, '.jpg');
    }
    return null;
};
export default getVideoPreviewImage;
